import {currentProjectStore} from 'common/report/stores/project-details';
import {ProjectFeatureFlag} from 'common/report/constants';
import {determineFeatureEligibility} from 'common/util/feature-sampling';

/** This determines if the feature is available for a project owner to toggle in settings. */
export function publicDashboardsEnabled(currentProject = currentProjectStore): boolean {
  const rollout =
    // Enable for 25 percent of organizations
    currentProject.hasFetchedValue() &&
    determineFeatureEligibility(currentProject.value.organizationId.toString(), `public-dashboards`, 50);

  const ffEnabled = currentProject.value?.hasFeatureFlag(ProjectFeatureFlag.PublicDashboards);

  return ffEnabled || rollout;
}
